import { defineMessages } from "react-intl";

const messages = defineMessages({
    h2: {
        id: "aboutus.contribution.h2",
    },
    p: {
        id: "aboutus.contribution.p",
    },
    share: {
        id: "aboutus.contribution.share",
    },
    translate: {
        id: "aboutus.contribution.translate",
    },
    donate: {
        id: "aboutus.contribution.donate",
    },
});

export default messages;
